import script from "./JoinCampaign.vue?vue&type=script&setup=true&lang=js"
export * from "./JoinCampaign.vue?vue&type=script&setup=true&lang=js"

import "./JoinCampaign.vue?vue&type=style&index=0&id=94cb8f70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94cb8f70"]])

export default __exports__